const PaySuccessIcon = ({ width = 32, height = 32, color = '#000000' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
      <g clipPath="url(#clip0_50616_155349)">
        <path
          d="M44.5956 15.08L41.5356 18.16C42.1756 19.98 42.5156 21.96 42.5156 24C42.5156 33.92 34.4356 42 24.5156 42C14.5956 42 6.51562 33.92 6.51562 24C6.51562 14.08 14.5756 6 24.5156 6C28.7156 6 32.5956 7.46 35.6556 9.88L38.4956 7.04C34.6956 3.88 29.8156 2 24.5156 2C12.3756 2 2.51562 11.88 2.51562 24C2.51562 36.12 12.3756 46 24.5156 46C36.6556 46 46.5156 36.14 46.5156 24C46.5156 20.82 45.8356 17.8 44.5956 15.08Z"
          fill="black"
        />
        <path
          d="M48.5039 7.5L45.7188 4.71485L23.9407 26.5163L23.9407 29.4997L26.7259 29.4997L48.5039 7.5Z"
          fill="black"
        />
        <path
          d="M17.0003 20.9997L14.1719 23.8281L19.9988 29.5012L22.9841 29.4862L22.9988 26.5012L17.0003 20.9997Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_50616_155349">
          <rect width={width} height={height} fill={color} transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PaySuccessIcon
